module.exports = __webpack_public_path__ + "img/lemonade_logo.13cb481e.svg";